import { easeIn } from 'framer-motion';

export const pageVariants = {
  initial: {
    height: '100vh',
    bottom: 0,
  },
  animate: {
    height: 0,
    transition: {
      duration: 0.7,
      ease: easeIn,
    },
  },
};

export const container = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      //  delayChildren: 0.01,
    },
  },
};

export const intro = {
  initial: {
    opacity: 0,
    y: -20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: easeIn,
    },
  },
};

export const details = {
  initial: {
    opacity: 0,
    y: -20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: easeIn,
    },
  },
};
